import { DashboardCards } from "../styled/CustomCard"
import { useState } from "react"
import styled from "styled-components"

const EnrolledParticipants = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  background-color: #eee;
  padding: 0.75rem;

  @media screen and (max-width: 1400px) {
    min-height: 100%;
  }

  span {
    display: block;
    font-weight: normal;
    font-size: 1rem;
  }
`

const Labels = styled.div`
  font-size: small;
  color: #999;
  padding-bottom: 0.5rem;
`

const Regions = styled.div`
  font-size: 0.9rem;
  display: flex;
  flex-direction: column;

  .row {
    border-bottom: 1px solid #eee;
    padding: 0.5rem 0;
  }
`

type Participants = {
  enrolledParticipantsCount: number
  regionName: string
  salesClaimMadeCount: number
}

type ParticipantsByRegion = {
  participantStatsByRegion: Participants[]
  totalEnrolledParticipantsCount: number
}

type Props = {
  participantsByRegion: ParticipantsByRegion
}

const ParticipantsCard = ({ participantsByRegion }: Props) => {
  const [participant] = useState<ParticipantsByRegion>(participantsByRegion)

  return (
    <div className="container-fluid h-100">
      <DashboardCards>
        <div className="row border-bottom">
          <div className="col">
            <h6>Participants by Region</h6>
          </div>
        </div>
        <div className="row pt-2">
          <div className="col-xl-6 col-lg">
            <EnrolledParticipants>
              <div className="row">
                <div className="col-12">
                  {participant?.totalEnrolledParticipantsCount}
                </div>
                <div className="col-12">
                  <span>Total Participants Enrolled</span>
                </div>
              </div>
            </EnrolledParticipants>
          </div>
          <div className="col-xl-6 col-lg-6 pt-2">
            <Labels>
              <div className="row">
                <div className="col">Enrolled</div>
                <div className="col text-end">Sales Claims</div>
              </div>
            </Labels>
            <Regions>
              {participant.participantStatsByRegion?.map(
                (p: Participants, index: number) => (
                  <div className="row" key={index}>
                    <div className="col">{p?.enrolledParticipantsCount}</div>
                    <div className="col text-end fw-bold">
                      {p?.salesClaimMadeCount}
                    </div>
                  </div>
                )
              )}
            </Regions>
          </div>
        </div>
      </DashboardCards>
    </div>
  )
}

export default ParticipantsCard
